import queryString from './queryString';
import appConfig from '../../../config';

const baseUrl = 'https://secure.espn.com/core/format/modules/head/i18n';

export default function getI18nInclude() {
    const query = {
        'edition-host': 'espn.com',
        lang: 'en',
        region: 'us',
        site: 'espn',
        'site=type': 'full',
        type: 'ext',
        build: '0.362.4.1',
        'edition-view': 'espn-en-us',
        edition: 'espn-en-us'
    };
    return `${baseUrl}${queryString(query)}`;
};



// WEBPACK FOOTER //
// ./app/lib/format/getI18nInclude.js